module.exports = __webpack_public_path__ + "img/57.bab8c1cd.gif";